import * as React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { bind, inject } from '../../utils/decorators';
import { ApiStore } from '../../stores/ApiStore';
import PagedList from '../site/PagedList';
import { IRechnung, IRechnungArt, IRechnungListePaginatedResponse, IRechnungStatus } from '../../models/ApiTypes';
import Pager from '../site/Pager';
import FilterBox from '../site/FilterBox';
import { Badge, Col, FormControl, InputGroup, ListGroup, ListGroupItem, Panel, Row } from 'react-bootstrap';
import { UiStore } from '../../stores/UiStore';
import { numberformatMoney } from '../../utils/numberformat';
import FaIcon from '../site/FaIcon';

/** Einzelnes Listenelement mit Kopfinformationen zu Rechnung/Gutschrift */
class BelegListItem extends React.Component<{rechnung: IRechnung}, {}> {

  @inject(UiStore) uiStore: UiStore;

  render() {
    const { rechnung } = this.props;
    return (
      <ListGroupItem
        header={
          <div>
            {rechnung.art} Nr. {rechnung.renr}
            <Badge className={`rechnung-badge-${rechnung.statustext}`} style={{float: 'right'}}>{rechnung.statustext}</Badge>
          </div>}
        onClick={() => this.uiStore.navigateTo(`/beleg/${rechnung.renr}`)}>
        <div>
          {rechnung.datum}
          {rechnung.typtext !== '' && <span> - Zu {rechnung.typtext}</span>}
          {rechnung.refnr && <span> - Zu Auftrag {rechnung.refnr}</span>}
          {rechnung.netto && <span className="pull-right">{numberformatMoney(rechnung.netto)} €</span>}
        </div>
      </ListGroupItem>
    );
  }
}

@observer
export default class Belege extends PagedList<{}> {


  // Die Liste beinhaltet nur die Status die im Portal Sinn machen
  private rechnungStatusListe: Array<IRechnungStatus> = [
    { wert: -999, text: 'Alle Status' },
    { wert: 0, text: 'Nur offen' },
    { wert: 2, text: 'Nur bezahlt' },
    { wert: 1, text: 'Nur teilbezahlt' }
  ];

  // Die Liste beinhaltet nur die Arten die im Portal Sinn machen
  private rechnungArtListe: Array<IRechnungArt> = [
    { kuerzel: '', text: 'Alle Arten' },
    { kuerzel: 'R', text: 'Nur Rechnungen' },
    { kuerzel: 'G', text: 'Nur Gutschriften' },
    { kuerzel: 'K', text: 'Nur Korrekturen' }
  ];

  @inject(ApiStore) apiStore: ApiStore;
  @observable rechnungen?: IRechnungListePaginatedResponse;
  @observable filterRechnungStatus: IRechnungStatus = this.rechnungStatusListe[0];
  @observable filterRechnungArt: IRechnungArt = this.rechnungArtListe[0];

  @action setRechnungen(rechnungen: IRechnungListePaginatedResponse) {
    this.rechnungen = rechnungen;
  }

  @bind @action paginate(pageNumber: number) {
    this.setCurrentPage(pageNumber);
    this.ladeRechnungen();
  }

  async ladeRechnungen() {
    let res = await this.apiStore.rechnungsuebersicht(this.currentPage, this.filter, this.filterRechnungStatus.wert >= 0 ? this.filterRechnungStatus.wert : null, this.filterRechnungArt.kuerzel !== '' ? this.filterRechnungArt.kuerzel : null);
    if (res.ok) {
      this.setLastPage(res.json.last_page);
      this.setTotal(res.json.total);
      this.setRechnungen(res.json);
    }
  }

  componentDidMount() {
    this.ladeRechnungen();
  }

  @bind @action handleRechnungStatusChanged(event: React.FormEvent<FormControl>) {
    let status = this.rechnungStatusListe.find((e) => {return e.wert === parseInt((event.target as HTMLInputElement).value, 10); });
    this.filterRechnungStatus = status ? status : this.rechnungStatusListe[0];
    this.paginate(1);
  }

  @bind @action handleRechnungArtChanged(event: React.FormEvent<FormControl>) {
    let status = this.rechnungArtListe.find((e) => {return e.kuerzel === (event.target as HTMLInputElement).value; });
    this.filterRechnungArt = status ? status : this.rechnungArtListe[0];
    this.paginate(1);
  }

  render() {
    return (
      <div className="maxwidth">
        <h2>Belegübersicht</h2>
        {!this.rechnungen ? <div className="maxwidth">Lade Belege...</div> : (
          <div>
            <Row>
              <Col md={6}>
                <InputGroup className="filter-group">
                  <InputGroup.Addon><FaIcon icon="folder-open" /></InputGroup.Addon>
                  <FormControl componentClass="select" placeholder="select" className="filter-box" value={this.filterRechnungStatus.wert} onChange={this.handleRechnungStatusChanged}>
                    {this.rechnungStatusListe.map((e) => ( <option key={e.wert} value={e.wert}>{e.text}</option> ))};
                  </FormControl>
                </InputGroup>
              </Col>
              <Col md={6}>
                <InputGroup className="filter-group">
                  <InputGroup.Addon><FaIcon icon="folder-open" /></InputGroup.Addon>
                  <FormControl componentClass="select" placeholder="select" className="filter-box" value={this.filterRechnungArt.kuerzel} onChange={this.handleRechnungArtChanged}>
                    {this.rechnungArtListe.map((e) => ( <option key={e.kuerzel} value={e.kuerzel}>{e.text}</option> ))};
                  </FormControl>
                </InputGroup>
              </Col>
            </Row>
            <FilterBox onChange={this.handleFilterList} placeholder="Suchen (Belegnr., Auftrag)" />
            <Panel>
              <ListGroup fill={true} className="auftragsliste">
                {this.rechnungen && this.rechnungen.data.length === 0 && (<ListGroupItem>keine Einträge</ListGroupItem>)}
                {this.rechnungen && this.rechnungen.data.map((rechnung, index) => <BelegListItem key={index} rechnung={rechnung}/>)}
              </ListGroup>
            </Panel>
            <Pager items={this.lastPage} onSelect={this.paginate} activePage={this.currentPage}/>
          </div>
        )}
        </div>
    );
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/belege/Belege.tsx